// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).ace.define(
  'ace/theme/atomOneDark',
  ['require', 'exports', 'module', 'ace/lib/dom'],
  (
    acequire: (path: string) => {
      importCssString: (...args: unknown[]) => void;
    },
    exports: Record<string, unknown>
  ): void => {
    exports.isDark = true;
    exports.cssClass = 'ace-one-dark';
    exports.cssText = `
.ace-one-dark .ace_gutter {
  background: #1e1e1e;
  color: rgba(255, 255, 255, 0.7);
  padding-right: 10px;
}

.ace-one-dark .ace_print-margin {
  width: 1px;
  background: #555651
}

.ace-one-dark {
  background-color: #353535;
  color: #fff
}

.ace-one-dark .ace_cursor {
  color: #528BFF
}

.ace-one-dark .ace_marker-layer .ace_selection {
  background: #3D4350
}

.ace-one-dark.ace_multiselect .ace_selection.ace_start {
  box-shadow: 0 0 3px 0px #353535;
}

.ace-one-dark .ace_marker-layer .ace_step {
  background: rgb(102, 82, 0)
}

.ace-one-dark .ace_marker-layer .ace_bracket {
  margin: -1px 0 0 -1px;
  border: 1px solid #ABB2BF
}

.ace-one-dark .ace_marker-layer .ace_active-line {
  background: #202020
}

.ace-one-dark .ace_gutter-active-line {
  background-color: #272727
}

.ace-one-dark .ace_marker-layer .ace_selected-word {
  border: 1px solid #49483E
}

.ace-one-dark .ace_invisible {
  color: #3B4048
}

.ace-one-dark .ace_entity.ace_name.ace_tag,
.ace-one-dark .ace_meta.ace_tag,
.ace-one-dark .ace_constant,
.ace-one-dark .ace_storage {
  color: #E06C75
}

.ace-one-dark .ace_keyword{
  color: #61AFEF
}

.ace-one-dark .ace_punctuation,
.ace-one-dark .ace_punctuation.ace_tag {
  color: #ABB2BF
}

.ace-one-dark .ace_constant.ace_support.ace_fonts,
.ace-one-dark .ace_constant.ace_character,
.ace-one-dark .ace_constant.ace_support,
.ace-one-dark .ace_constant.ace_language,
.ace-one-dark .ace_constant.ace_numeric,
.ace-one-dark .ace_constant.ace_other {
  color: #D19A66
}



.ace-one-dark .ace_invalid {
  color: #F8F8F0;
  background-color: #F92672
}

.ace-one-dark .ace_invalid.ace_deprecated {
  color: #F8F8F0;
  background-color: #AE81FF
}

.ace-one-dark .ace_support.ace_type{
    color: #ABB2BF
}

.ace-one-dark .ace_constant.ace_language.ace_escape,
.ace-one-dark .ace_keyword.ace_operator,
.ace-one-dark .ace_support.ace_function {
  color: #56B6C2
}

.ace-one-dark .ace_fold {
  background-color: #A6E22E;
  border-color: #ABB2BF
}

.ace-one-dark .ace_storage.ace_type{
    color: #C678DD;
}


.ace-one-dark .ace_support.ace_class {
  font-style: italic;
  color: #66D9EF
}

.ace-one-dark .ace_entity.ace_other,
.ace-one-dark .ace_entity.ace_other.ace_attribute-name,
.ace-one-dark .ace_variable {
  color: #D19A66
}

.ace-one-dark .ace_string,
.ace-one-dark .ace_list.ace_markup,
.ace-one-dark .ace_constant.ace_language.ace_escape .ace_string,
.ace-one-dark .ace_string.ace_attribute-value {
    color: #98C379
}

.ace-one-dark .ace_entity.ace_name.ace_function {
  color: #61AFEF
}

.ace-one-dark .ace_operator {
    color: #ABB2BF;
}

/*.ace-one-dark .ace_string, */
.ace-one-dark .ace_identifier,
.ace-one-dark .ace_variable.ace_parameter{
  color: #ABB2BF
}

.ace-one-dark .ace_comment {
  color: #5C6370;
  font-style: italic;
}

.ace-one-dark .ace_indent-guide {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAEklEQVQImWPQ0FD0ZXBzd/wPAAjVAoxeSgNeAAAAAElFTkSuQmCC) right repeat-y
}`;

    const dom: { importCssString: (...args: unknown[]) => void } =
      acequire('../lib/dom');
    dom.importCssString(exports.cssText, exports.cssClass);
  }
);
